import { GridCellProps } from '@progress/kendo-react-grid';
import React from 'react';
import { GearGridCell } from './GearGridCell';
import { GEAR_ACTIONS_ALLOWED_FOR_DOCUMENT } from '../../../Model/enums/GearUserAllowedActions';
import { PERMISSIONS_FIELD } from '../../../config/consts';
import { useGlobalizationContext } from '../../../context/globalization/GlobalizationContext';
import { useTranslation } from '../../../context/globalization/useTranslation';

const getActionKey = (actionValue: number): string => {
  for (const key in GEAR_ACTIONS_ALLOWED_FOR_DOCUMENT) {
    if (GEAR_ACTIONS_ALLOWED_FOR_DOCUMENT[key as keyof typeof GEAR_ACTIONS_ALLOWED_FOR_DOCUMENT] === actionValue) {
      return key.charAt(0) + key.slice(1).toLowerCase();
    }
  }
  return actionValue.toString();
};

export const ActionsCell: React.FC<GridCellProps> = props => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);
  const actionsArray = props.dataItem[PERMISSIONS_FIELD] as number[];

  const hasOtherActions = actionsArray.some(value => value !== 0);
  const filteredActions = hasOtherActions ? actionsArray.filter(value => value !== 0) : actionsArray;

  const actionNames = filteredActions
    .map(value => {
      const actionKey = getActionKey(value);
      return translate(`grid.filter${actionKey}`);
    })
    .join(', ');

  return (
    <GearGridCell {...props} title="">
      {actionNames}
    </GearGridCell>
  );
};
